export {default} from './DeviceConfig';
